export { default, links, meta } from "/Users/mitchel/sites/github/remix-portfolio/app/routes/projects/index.tsx";